<div>
    <div fxFlex="100" fxFlex.lt-md="100">
        <mat-card class="table-card" appCard>
            <mat-card-content>
                <table mat-table [dataSource]="dataSource" style="width: 100%">
<!--                    <ng-container style="text-align: center"-->
<!--                            *ngFor="let column of displayedColumns"-->
<!--                            [matColumnDef]="column"-->
<!--                    >-->
<!--                        <th mat-header-cell *matHeaderCellDef>-->
<!--                            {{ labels[column] | translate }}-->
<!--                        </th>-->

<!--                        <td mat-cell *matCellDef="let type" style="text-align: center">-->
<!--                            <span *ngIf="type[column]">{{ type[column] | typedValue | async | translate }}</span>-->
<!--                            <span *ngIf="!type[column]">-</span>-->
<!--                        </td>-->
<!--                    </ng-container>-->
                    <ng-container matColumnDef="bidCls">
                        <th style="text-align: center" mat-header-cell *matHeaderCellDef>{{labels['bidCls']|translate}}</th>
                        <td mat-cell *matCellDef="let element; let i = index" style="text-align: center">
                            <span *ngIf="detailsoffre['procedureType'] !== '4' ">-</span>
                            <div *ngIf="detailsoffre['procedureType'] === '4'">
                                <button style="color: #3498db" mat-button type="button" (click)="particpatepreselection(element,i, 'PropositionTechnique')">
                                    {{'Proposition technique'|translate}}
                                </button>
                            </div>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="licenseCd">
                        <th style="text-align: center" mat-header-cell *matHeaderCellDef>{{labels['licenseCd']|translate}}</th>
                        <td mat-cell *matCellDef="let element; let i = index" style="text-align: center !important">
                           <span *ngIf="detailsoffre['procedureType'] !== '3'">-</span>
                            <div style="text-align: center!important;" *ngIf="detailsoffre['procedureType'] === '3'">
                                <button       style="color: #3498db" mat-button type="button" (click)="particpatepreselection(element,i, 'DossierCandidature')">
                                    {{'Dossier candidature'|translate}}
                                </button>
                            </div>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="groupement">
                        <th style="text-align: center" mat-header-cell *matHeaderCellDef>{{'Acte de groupement'|translate}}</th>
                        <td mat-cell *matCellDef="let element; let i = index" style="text-align: center">
                            <button       style="color: #3498db" mat-button type="button"  (click)="particpategroupement(element,i)">
                                {{'groupement'|translate}}
                            </button>

                        </td>
                    </ng-container>
                    <ng-container matColumnDef="action">
                        <th style="text-align: center" mat-header-cell *matHeaderCellDef> {{ "Participation à l'appel d'offres" | translate }}</th>
                        <td mat-cell *matCellDef="let element; let i = index" style="text-align: center">
                            <div  *ngIf="detailsoffre['procedureType'] !== '3' && detailsoffre['procedureType'] !== '4'&&detailsoffre.onOffType!='3'"><!--&detailsoffre.onOffType=='1'-->
                                <button       style="color: #3498db" mat-button type="button"  (click)="particpate(element,i)">
                                    {{'offre'|translate}}
                                </button>

                            </div>
                            <span *ngIf="detailsoffre['procedureType'] === '3' || detailsoffre['procedureType'] === '4'||detailsoffre.onOffType=='3'">-</span>

                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="getcolum()"></tr>
                    <tr mat-row *matRowDef="let row; columns: getcolum()"></tr>
                </table>
  <!--              <app-empty-list-container
                        [withoutBorder]="true"
                        [list]="dataSource.data"
                >
                </app-empty-list-container>-->
            </mat-card-content>
        </mat-card>
    </div>
</div>
